<template>
	<div class="card-generator">
		<form 
			method="post" 
			accept-charset="UTF-8" 
			@submit.prevent="submitForm"
		>		
			<input type="hidden" name="id" :value="id" />	
			<input type="hidden" name="imageUrl" :value="imageUrl" />
			<input type="hidden" name="imageTeaserUrl" :value="imageTeaserUrl" />
			<input type="hidden" name="videoUrl" :value="videoUrl" />
			<input type="hidden" name="template" :value="template" />
			<input type="hidden" name="downloadToServer" :value="downloadToServer" />
			<input type="hidden" name="imageFileType" :value="imageFileType" />

			<div class="uk-relative">
				<div v-if="generatedVideo || generatedVideoUrl">
					<a :href="generatedVideoUrl || generatedVideo" target="_blank">
						<!--<video autoplay playsinline muted :src="generatedVideoUrl || generatedVideo" style="--aspect-ratio: 16 / 9;" @error="noVideoFound"></video>-->
				
						<video 
						  v-if="showVideo" 
						  autoplay 
						  playsinline 
						  muted 
						  :src="generatedVideoUrl || generatedVideo" 
						  style="--aspect-ratio: 16 / 9;" 
						  @error="noVideoFound">
						</video>
						
						<img 
						  v-else 
						  :src="defaultVideoPlaceholder" 
						  alt="No video found" 
						  style="--aspect-ratio: 16 / 9;">
						  
					</a>		
				</div>
				<div v-else>
					<a :href="generatedCard" v-show="!freshGeneratedCard" target="_blank">
						<img :src="(!generatedCard) ? defaultImage : generatedCard" @error="noImageFound" class="uk-width-1-1" />
					</a>
					<a :href="freshGeneratedCard" v-show="freshGeneratedCard" target="_blank">
						<img :src="freshGeneratedCard" @error="noImageFound" class="uk-width-1-1" />
					</a>		
				</div>	
				<span class="uk-position-center" v-show="indicator">
					<loading-indicator :size="40"></loading-indicator>
				</span>
			</div>

			<!-- template formats -->
			<div  class="uk-margin-small-top" v-if="templateFormats && templateFormats.length > 0">
				<select name="templateFormat" class="uk-select uk-form-small">
					<option v-for="format in templateFormats" :key="format.id" :value="format.id" >
						{{ format.id }} 
					</option>
				</select>			
			</div>	

			<!-- template text fields -->
			<div :class="{'visually-hidden': hideFormFields}" v-for="(element, index) in textElements" :key="index" class="uk-margin-top">
				<textarea
					v-model="formData[element]"
					:name="'element_' + element"
					class="uk-textarea"
					:placeholder="element"
					@input="autoGrow($event)"
				></textarea>
			</div>
			
			<!-- video card -->
			<div v-if="videoUrl" class="uk-margin-small-top">
				<span><input type="checkbox" name="muted" value="1" /> Muted </span>
				<!--<span v-show="generatedVideo || generatedVideoUrl">
					<a :href="generatedVideoUrl || generatedVideo" target="_blank" style="margin-left: 65px">link</a>
				</span>-->
				<div>
					<label>Start position (sec)</label>
					<input type="text" name="startPosition" value="1" class="uk-width-1-1 uk-input-small">
				</div>
			</div>
			<div class="uk-margin-small-top">
				<button v-show="!indicator" type="submit" class="uk-text-center uk-button uk-button-small uk-width-1-1 uk-button-secondary">
					{{ buttonText }}
				</button> 
			</div>
				
		</form>
			
		<div class="uk-text-small uk-alert uk-margin-remove" 
			style="margin-top: 20px !important"
			v-html="response" 
			v-show="response" 
			v-bind:class="{ 'uk-alert-success' : response == true, 'uk-alert-danger' : success == false }"
			@click="hideResponse"
		>
		</div>					
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
	components: { LoadingIndicator },
	props: {
		id: { type: Number, default: Math.floor(Math.random() * 1000), required: true },
		generatedCard: String,
		generatedVideo: String,
		templates: Array,
		platformType: String,
		imageFileType: String,
		imageUrl: String,
		imageTeaserUrl: String,
		videoUrl: String,
		downloadToServer: { type: Boolean, default: false },
		buttonText: { type: String, default: 'Generate card' },
		cardsUrl: { type: String, default: 'https://content.site.com/cards' },
		alertIfCardIsMissing: { type: Boolean, default: false },
		hideFormFields: { type: Boolean, default: false },
		textElementValues: { type: Array, default: () => [] },
	},
	data() {
		return {
			apiUrl: '/actions/_cards/card-generator',
			formData: {},
			template: null,
			textElements: [],
			indicator: false,
			response: false,
			success: false,    
			freshGeneratedCard: null,
			defaultImage: `data:image/svg+xml;base64,${btoa(`
			<svg xmlns="http://www.w3.org/2000/svg" width="200" height="300">
				<rect width="200" height="300" fill="#cccccc"/>
				<text x="50%" y="50%" font-size="20" fill="#333" text-anchor="middle" dy=".3em">no card found</text>
			</svg>
			`.trim())}`,
			defaultVideoPlaceholder: `data:image/svg+xml;base64,${btoa(`
			  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="356">
				<rect width="200" height="356" fill="#cccccc"/>
				<text x="50%" y="50%" font-size="20" fill="#333" text-anchor="middle" dy=".3em">no video found</text>
			  </svg>
			`.trim())}`,
			showVideo: true,
			isPolling: false,
			poller: null,
			generatedVideoUrl: null,
			templateFormats: [],
			templateFormat: null
		};
	},
	mounted() {
		
		var component = this;
			
		// Set initial template
		component.template = component.templates[0];
				
		// Fetch template formats
		component.fetchTemplateFormats();
		
		// Fetch text field elements
		component.fetchTemplateTextFields();
	},
	methods: {
		autoGrow(event) {
			console.log('test')
			const textarea = event.target;
			textarea.style.height = "auto"; 
			textarea.style.height = `${textarea.scrollHeight}px`; 
		},
		fetchTemplateTextFields() {
			
			var component = this;	
						
			if(component.platformType != "abyssale") return;
					
			if(!component.template) {
				component.textElements = [];
				return;
			}
			
			component.$logger("app/components/card-generator/fetch-template-elements");

			axios.post(`${component.apiUrl}/get-template-data`, {
					template: component.template
				}
			)
			.then(response => {			
				var elements = response.data.response.elements;
										
				if (elements) {
				  // Filter and map text elements
				  this.textElements = elements
					.filter(el => el.type === "text")  
					.map(el => el.name);
				
				  // Populate formData with textElementValues if provided
				  this.textElements.forEach(element => {
					const matchingValue = this.textElementValues.find(
					  item => item.element === element
					);
					this.formData[element] = matchingValue ? matchingValue.value : '';
				  });
				
				  //console.log(this.textElements);
				}	
			})
			.catch(error => {
				console.error('app/components/card-generator/error fetching template elements:', error);
			});	
		},
		fetchTemplateFormats() {
			
			var component = this;
					
			if(component.platformType != "abyssale") return;
		
			component.$logger("app/components/card-generator/fetch-template-formats");
		
			if(!component.template) {
				component.templateFormats = [];
				return;
			}
			
			axios.post(`${component.apiUrl}/get-template-data`, {
					template: component.template
				}
			)
			.then(response => {
				
				this.$logger('app/components/card-generator/fetchTemplateFormats');			
				this.$logger(response.data.response.formats)
				
				component.templateFormats = response.data.response.formats;
				
				if (component.templateFormats && component.templateFormats.length > 0) {
					component.templateFormat = component.templateFormats[0].id; // Auto-select the first format
					component.templateFormat = component.templateFormats[0].id;
				} else {
						
				}
								
			})
			.catch(error => {
				console.error('Error fetching template data:', error);
				this.$logger('app/components/card-generator/fetchTemplateFormats', 'error');
				this.$logger(error, 'error');
			});	
		},
		submitForm(e) {
			
			// Data
			var component = this;
			
			// Form data
			var form = e.target;
			var formData = new FormData(form);
						
			// Add dynamic fields from formData to the FormData object
			Object.entries(this.formData).forEach(([key, value]) => {
				// Check if the key already exists in the FormData object
				if (!formData.has(key)) {
					formData.append(key, value);
				}
			});
			
			// Check for valid input url
			if(component.imageUrl && !component.$helper.isValidUrl(component.imageUrl) || 
				component.videoUrl && !component.$helper.isValidUrl(component.videoUrl)
			) {
				
				if(component.imageUrl) {
					component.response = 'Er is geen geldige bron-afbeelding gevonden. Upload een social card in je artikel.'
				} else {
					component.response = 'Er is geen geldige bron-video gevonden. Upload die in je artikel.'
				}
				
				setTimeout(function() {
					component.response = null;
				}, 10000);
				return false;	
			}
			
			// Enable indicator
			component.indicator = true;
			
			// Request		
			axios({
				method: 'post',
				url: component.apiUrl + '/generate', 
				responseType: 'json',		
				data: formData,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Accept' : 'application/json'
				}
			})
			.then(function(response) {
				
				component.$logger("app/components/card-generator/submitForm/response/");							
				component.$logger(response);
								
				// Sucess 			
				if(response.data.success) {
					
					component.success = true;
					
					if(component.platformType == "bannerbear") {
						component.freshGeneratedCard = response.data.response.image_url_jpg + '?v=' +  Math.floor(Date.now() / 1000);
					} else if(component.platformType == "abyssale") {
						
						// Check for generation_request_id in case of async requests, we should poll API results coming back
						if(response.data.request_id) {
							component.startPolling(response.data.request_id);
						} else {
							component.freshGeneratedCard = response.data.response.file.url + '?v=' +  Math.floor(Date.now() / 1000);
							component.indicator = false;		
						}
						
					}	 else {
						component.freshGeneratedCard = null;
						component.indicator = false;		
					}				
					
				// Error
				} else {
									
					component.indicator = false;				
					component.success = false;
					component.response = response.data.response;
					
					setTimeout(function() {
						component.response = false;
					}, 15000);				
				}			
			})
			.catch(function(e) {
				
				component.$logger(e, 'error');
				
				component.indicator = false;
				component.success = false;
				component.response = e;
			
				setTimeout(function() {
					component.response = false;
				}, 15000);					
			});				
		},
		hideResponse() {
			this.response = false;
		},
		noImageFound(e) {
			e.target.src = this.defaultImage;
		},
		noVideoFound(e) {
			this.showVideo = false; 
		},
		startPolling(requestId) {
			var component = this;
			component.isPolling = true;
		
			const pollInterval = 3000; // Poll every 5 seconds
			const url = '/actions/_cards/card-generator/status';
			
			const poll = () => {
				axios.post(url, { 
						requestId, 
						downloadToServer: component.downloadToServer, 
						id: component.id 
					})
					.then(response => {
																			
						if (response.data.success === false) {
							console.error('Error:');
							clearInterval(component.poller);
						} else {
							if (response.data.success === false) {
								console.error('Error:');
								clearInterval(component.poller);
							} else {
								// Check if the generation process is finalized
								if (response.data.is_finalized) {
									
									this.$logger('app/components/card-generator/startPolling/finalized');
									this.$logger(response.data);
									
									clearInterval(component.poller);
									
									component.indicator = false;
									component.isPolling = false;
									
									component.generatedVideoUrl = response.data.banners[0].file.url + '?v=' +  Math.floor(Date.now() / 1000);
									
								} else {
									this.$logger('app/components/card-generator/startPolling/processing...');
								}
							}
						}
					})
					.catch(error => {
						this.$logger('app/components/card-generator/startPolling/error','error');
						this.$logger(error, 'error');
						
						clearInterval(component.poller);
						component.indicator = false;
						component.isPolling = false;							
					});
			};
			component.poller = setInterval(poll, pollInterval);		
		},
	},
};
</script>

<style scoped>
.visually-hidden {
	display: none;
}
</style>
